type HelpArticles = Record<string, `${typeof ARTICLES_URL}/${number}`>;

const ARTICLES_URL = 'https://help.postscript.io/hc/en-us/articles';

/**
 * Dictionary for help center article URLs.
 *
 * Zendesk ignores anything after the id (permalink) portion of the URL,
 * allowing the auto-generated title portion of the URL to change over time
 * without breaking links. We only use the ID in this dictionary to keep things
 * simple.
 *
 * Additionally, linking to fragments can be buggy in Zendesk (they have custom
 * scrollTo logic it would appear), so we're avoiding them here too. If you need
 * a hash in the URL, use at your own risk wherever you consume the dictionary.
 * @type {Record<string, `${typeof HELP_URL}/${number}`>
 */

export const HELP_ARTICLES: HelpArticles = {
  addSdkToHeadlessShop: `${ARTICLES_URL}/4407642816795`,
  addSdkThemeAppExtension: `${ARTICLES_URL}/20356464186523`,
  bestPracticesForGrowingYourSubscriberList: `${ARTICLES_URL}/1260804683549`,
  createASegment: `${ARTICLES_URL}/1260804633530`,
  customizeYourDesktopPopupWithCss: `${ARTICLES_URL}/4403878874267`,
  customizeYourMessages: `${ARTICLES_URL}/4404916872475`,
  customizeYourMobilePopupWithCss: `${ARTICLES_URL}/4403879457947`,
  desktopPopupCssTemplateGallery: `${ARTICLES_URL}/4404200545435`,
  guideToSubscriberLifetimeValueArmrMetrics: `${ARTICLES_URL}/9539382199195`,
  mobilePopupTemplateGallery: `${ARTICLES_URL}/4404251105051`,
  popupCssCustomizationGlossary: `${ARTICLES_URL}/4403539639579`,
  sendSubscriberEmailDataToKlaviyo: `${ARTICLES_URL}/4565537532571`,
  usingCustomProperties: `${ARTICLES_URL}/13889438438043`,
  tfnVerification: `${ARTICLES_URL}/9232469975195`,
  businessLinks: `${ARTICLES_URL}/20281755443227`,
  salesTax: `${ARTICLES_URL}/20778971784347`,
  carrierFees: `${ARTICLES_URL}/4427783698331`,
  migratePopupsToOnsiteOptIn: `${ARTICLES_URL}/22712262519835`,
} as const;

type OptionalHash = `#${string}`;
type HelpCategories = Record<
  string,
  | `${typeof CATEGORIES_URL}/${number}`
  | `${typeof CATEGORIES_URL}/${number}${OptionalHash}`
>;

const CATEGORIES_URL = 'https://help.postscript.io/hc/en-us/categories';

/**
 * Dictionary for help center categories, including hashes.
 *
 * @type {Record<string, `${typeof HELP_CATEGORIES}/${number}${Hash}`>
 */
export const HELP_CATEGORIES: HelpCategories = {
  campaigns: `${CATEGORIES_URL}/4408034242715#section-4413995722011`,
};

export const SUPPORTED_DSC_COUNTRY_CODES = ['US', 'CA', 'NZ'];
export const SMS_SALES_VIEW_LOCAL_STORAGE_KEY = 'SMS_SALES_VIEW_LEVEL';

export const POSTSCRIPT_DARK_MODE = 'POSTSCRIPT_DARK_MODE';

export const MESSAGE_BUILDER_COMPLIANCE_OPEN =
  'MESSAGE_BUILDER_COMPLIANCE_OPEN';

// We define "core" triggers as any postscript-managed, non-partner trigger event.
export const CORE_EVENT_TRIGGER_NAMES = [
  'Attempted Delivery',
  'Checkout Started',
  'Customer Created',
  'Fulfillment Created',
  'Keyword Triggered',
  'Order Created',
  'Order Delivered',
  'Order Fulfilled',
  'Order In Transit',
  'Order Out For Delivery',
  'Order Ready For Pick-up',
  'Product Added to Cart',
  'Product Back in Stock',
  'Subscriber Created (Popup, Keyword, or API)',
  'Subscriber Reply (Non-Keyword)',
  'Subscriber Viewed Product',
];

export const APP_LAYOUT_CSS_SELECTORS = {
  FULLSCREEN_EDITOR: '.full-screen-editor',
  SIDEBAR_OPEN: '.sidebar-navigation-open',
} as const;

export const Channels = {
  SMS: 'SMS',
  RCS: 'RCS',
} as const;
